import colors from 'Constants/colors';
import { css } from 'styled-components';

const shadowStyle = css`
  box-shadow: 4px 4px 24px 0 ${colors.greyPearl};
`;

export default shadowStyle;
